























































import props from './common/props';
import Vue from 'vue';
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { deepEqual } from '@/utils/helpers';

export default Vue.extend({
  props: {
    ...props.base,
    ...props.time,
    calendars: props.detail.calendars
  },
  data() {
    return {
      currentCalendar: [1]
    };
  },
  computed: {
    ...mapState('calendar', ['calendarIds']),
    selected: {
      get() {
        return this.calendarIds;
      },
      set(val: number) {
        this.setCalendarIds(val);
      }
    } as any
  },
  methods: {
    ...mapMutations('calendar', {
      setCalendarIds: 'SET_CALENDAR_IDS'
    })
  },
  watch: {
    selected: {
      handler(selected, prevSelected) {
        this.$emit('updated', selected);
      },
      deep: true
    }
  }
});
